import { useState, useEffect } from 'react';
import {
    setAccessToken,
    setCurrentLang,
    setLastLogin,
    setMemberLS,
    getCurrentMember,
} from '../helpers/userCred';
import { useMemberContext } from '@/shared/contexts/memberContext';

const useMemberSessionSync = () => {
    const { setMember } = useMemberContext();
    const [isSync, setIsSync] = useState(true);

    useEffect(() => {
        const searchParam = new URLSearchParams(window.location.search);
        const l = searchParam.get('l');
        const lg = searchParam.get('lg');
        const lo = searchParam.get('lo');
        const a = searchParam.get('a');
        const m = searchParam.get('m');

        if (lo) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('member');
            localStorage.removeItem('memberActivated');
            localStorage.removeItem('lastLogin');
            localStorage.removeItem('LS_ROUTE_KEY');
            setMember(undefined);
            searchParam.delete('lo');
        }

        if (l) {
            setCurrentLang(l);
            searchParam.delete('l');
        }

        if (lg) {
            setLastLogin(lg);
            searchParam.delete('lg');
        }

        if (a) {
            setAccessToken(a);
            searchParam.delete('a');
        }

        if (m) {
            setMember(JSON.parse(m));
            setMemberLS(m);
            searchParam.delete('m');
        } else {
            const savedMember = getCurrentMember();
            if (savedMember) setMember(savedMember);
        }

        const nextTitle = '';
        const nextState = { additionalInformation: '' };
        const origin = window.location.origin;
        const currentPath = window.location.pathname;
        const strSearchParam = searchParam.toString();

        let nextURL = `${origin}${currentPath}`;

        if (strSearchParam) {
            nextURL = `${nextURL}?${strSearchParam}`;
        }

        window.history.replaceState(nextState, nextTitle, nextURL);

        setIsSync(false);
    }, [setMember]);

    return { isSync };
};

export default useMemberSessionSync;
